// extracted by mini-css-extract-plugin
var _1 = "FieldSet-module__animatedBackground--zp9OS";
var _2 = "FieldSet-module__fieldSet--hnzhY";
var _3 = "FieldSet-module__legend--Pvgqa";
var _4 = "FieldSet-module__marginNormal--Xczqe";
export { _1 as "animatedBackground", _2 as "fieldSet", _3 as "legend", _4 as "marginNormal" }
